
import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        threat:[],
        topalerts:null,
        cloudtypes:[],
    };
  };

const alertSlice = createSlice({
  name: 'vaptAlert',
  initialState:initialState(),
  reducers: {    
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setThreat(state,action)
    {
      state.threat= action.payload;
    },
    setTopAlerts(state, action){
      state.topalerts = action.payload;
    },
    setCloudTypes(state, action){
      state.cloudtypes = action.payload;
    },
  },
});

export const {
  setErrors,
  setThreat,
  setTopAlerts,
  setCloudTypes
} = alertSlice.actions;
export const vaptAlert = alertSlice.reducer;